
<!--
  - Copyright (c) 2021 by Leyton Group - All Rights Reserved.
  -  This source code, and resulting software, is the confidential and proprietary information
  -  ("Proprietary Information") and is the intellectual property ("Intellectual Property")
  -  of Leyton Group, Inc. ("The Company"). You shall not disclose such Proprietary Information
  -  and shall use it only in accordance with the terms and conditions of any and all license
  -  agreements you have entered into with The Company.
  -->

<template>
  <div class="auth-layout">
    <div class="h-100 container-fluid">
      <slot />

      <ModalNotification id="default-modal-notification"></ModalNotification>

    </div>
  </div>
</template>

<script>
import ModalNotification from '@/components/static/ModalNotification';
export default {
  name: 'AuthLayout',
  components: {ModalNotification},
};
</script>
